import api from './axios';

// =====================
// DTO (для канбана)
// =====================

export interface PipelineDto {
  id: number;
  name: string;
  color?: string;
}

// =====================
// Полные типы (для настроек и канбана)
// =====================

export type Pipeline = {
  id: number;
  name: string;
  color: string;
  order: number;
};

export type Stage = {
  id: number;
  pipelineId: number;
  name: string;
  color: string;
  order: number;
  isFinal: boolean;
  isFailed: boolean;
};

// =====================
// API функции
// =====================

export const getPipelines = async (): Promise<Pipeline[]> => {
  const res = await api.get<Pipeline[]>('/deals/pipelines');
  return res.data;
};

export const getStages = async (pipelineId: number): Promise<Stage[]> => {
  const res = await api.get<Stage[]>(`/deals/pipelines/${pipelineId}/stages`);
  return res.data;
};

export const createPipeline = async (data: { name: string; color: string }) => {
  const res = await api.post('/deals/pipelines', data);
  return res.data;
};

export const updatePipeline = async (id: number, data: any) => {
  const res = await api.put(`/deals/pipelines/${id}`, data);
  return res.data;
};

export const deletePipeline = async (id: number) => {
  const res = await api.delete(`/deals/pipelines/${id}`);
  return res.data;
};

export const createStage = async (pipelineId: number, data: any) => {
  const res = await api.post(`/deals/pipelines/${pipelineId}/stages`, data);
  return res.data;
};

export const updateStage = async (stageId: number, data: any) => {
  const res = await api.put(`/deals/pipelines/stages/${stageId}`, data);
  return res.data;
};

export const deleteStage = async (stageId: number) => {
  const res = await api.delete(`/deals/pipelines/stages/${stageId}`);
  return res.data;
};

// =====================
// PipelinesAPI (для канбана)
// =====================

export const PipelinesAPI = {
  getAll: () =>
    api.get<PipelineDto[]>('/deals/pipelines').then((r) => r.data),

  getStages: (pipelineId: number) =>
    api
      .get<Stage[]>(`/deals/pipelines/${pipelineId}/stages`)
      .then((r) => r.data),
};
